import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { get_banners } from '../store/reducers/homeReducer';
import { imgUrl } from '../utils/imgUrl';

const ArrowIcon = () => (
    <svg className='w-4 h-4' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
    </svg>
);

const Banner = () => {
    const dispatch = useDispatch();
    const { banners } = useSelector(state => state.home);

    useEffect(() => { dispatch(get_banners()); }, []);

    const firstBanner = banners.length > 0 ? banners[0] : null;

    return (
        <section className='pt-6 pb-2'>
            <div className='max-w-[1320px] mx-auto px-6'>
                <div className='grid gap-[14px] h-[480px] grid-cols-[1.6fr_1fr] md-lg:grid-cols-1 md-lg:h-auto'>
                    {/* ── Main hero panel ── */}
                    <div className='relative rounded-[24px] overflow-hidden flex items-center px-12 gap-6 md:px-7' style={{ background: 'linear-gradient(135deg, #cffafe 0%, #ecfeff 50%, #e0e7ff 100%)' }}>
                        {/* decorative circle */}
                        <div className='absolute top-[-100px] right-[-100px] w-[340px] h-[340px] rounded-full pointer-events-none' style={{ background: 'radial-gradient(closest-side, rgba(248,113,113,.25), transparent)' }}></div>

                        {/* Copy */}
                        <div className='relative z-10 flex-1'>
                            <span
                                className='inline-flex items-center gap-2 bg-white/70 px-[14px] py-[6px] rounded-full text-[12px] font-extrabold text-[#1e3a8a] tracking-[.06em] uppercase border border-white/90'
                                style={{ backdropFilter: 'blur(8px)' }}
                            >
                                <span className='w-[7px] h-[7px] rounded-full bg-[#f87171] flex-shrink-0' style={{ animation: 'dotPulse 1.8s infinite' }}></span>
                                Mayo · Mes de los peludos
                            </span>
                            <h1
                                className='font-bold text-[#1e3a8a] leading-[1.02] tracking-tight mt-4 mb-4'
                                style={{ fontFamily: "'Bricolage Grotesque', system-ui, sans-serif", fontSize: 'clamp(32px, 4vw, 52px)' }}
                            >
                                Todo para tu{' '}
                                <em className='not-italic text-[#0891b2] relative'>
                                    peludo
                                    <span className='absolute left-0 right-0 bottom-[3px] h-2 rounded-lg pointer-events-none' style={{ background: '#f87171', opacity: .35, zIndex: -1 }}></span>
                                </em>
                            </h1>
                            <p className='text-[16px] text-[#334155] max-w-[420px] mb-6 leading-relaxed'>
                                Las mejores marcas de alimento, accesorios y cuidado — con envío gratis en compras desde Q899.
                            </p>
                            <div className='flex gap-[10px] flex-wrap'>
                                <Link
                                    to='/shops'
                                    className='inline-flex items-center gap-[10px] px-[22px] py-[14px] rounded-[14px] font-bold text-[15px] text-white transition-all hover:-translate-y-[2px]'
                                    style={{ background: '#0891b2', boxShadow: '0 8px 22px -10px rgba(8,145,178,.55)' }}
                                >
                                    Ver la tienda <ArrowIcon />
                                </Link>
                                <Link
                                    to='/shops'
                                    className='inline-flex items-center gap-[10px] px-[22px] py-[14px] rounded-[14px] font-bold text-[15px] bg-white text-[#1e3a8a] border-[1.5px] border-[#e8e6e1] hover:border-[#1e3a8a] transition-all'
                                >
                                    Ver ofertas
                                </Link>
                            </div>
                        </div>

                        {/* Hero image / placeholder */}
                        <div className='relative flex-1 h-full min-h-[280px] sm:hidden'>
                            {firstBanner
                                ? <Link to={`/product/details/${firstBanner.link}`} className='absolute inset-0'>
                                    <img src={imgUrl(firstBanner.banner)} alt="" className='absolute inset-0 w-full h-full object-cover rounded-[20px]' />
                                  </Link>
                                : <div className='absolute inset-0 rounded-[20px] bg-white/50 flex items-center justify-center text-[80px] opacity-40'>🐾</div>
                            }
                            {/* Floating badges */}
                            <div className='absolute top-[18px] left-[-12px] z-10 bg-white rounded-[14px] px-[14px] py-[10px] flex items-center gap-[10px] text-[13px] font-bold text-[#0f172a]' style={{ boxShadow: '0 12px 30px -8px rgba(0,0,0,.18)' }}>
                                <div className='w-[32px] h-[32px] rounded-[10px] bg-[#cffafe] text-[#0891b2] flex items-center justify-center flex-shrink-0'>
                                    <svg className='w-4 h-4' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
                                </div>
                                Envío en 24h
                            </div>
                            <div className='absolute bottom-6 right-[-10px] z-10 bg-[#f87171] rounded-[14px] px-[14px] py-[10px] flex items-center gap-[10px] text-[13px] font-bold text-white' style={{ boxShadow: '0 12px 30px -8px rgba(0,0,0,.18)' }}>
                                <div className='w-[32px] h-[32px] rounded-[10px] bg-white/25 flex items-center justify-center flex-shrink-0'>
                                    <svg className='w-4 h-4' viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" /></svg>
                                </div>
                                +12k clientes
                            </div>
                        </div>
                    </div>

                    {/* ── Side promo cards ── */}
                    <div className='grid gap-[14px] grid-rows-2'>
                        <Link
                            to='/shops'
                            className='relative rounded-[22px] overflow-hidden p-6 text-white flex flex-col justify-between group'
                            style={{ background: 'linear-gradient(135deg, #f87171 0%, #fb7185 60%, #ef4444 100%)' }}
                        >
                            <div className='absolute top-[-30px] right-[-30px] w-[140px] h-[140px] rounded-full bg-white/12 pointer-events-none'></div>
                            <span className='self-start bg-white/22 border border-white/30 px-[11px] py-[5px] rounded-full text-[11px] font-extrabold tracking-[.06em] uppercase'>Nuevo</span>
                            <div>
                                <h3 className='font-bold text-[22px] leading-[1.05] tracking-tight mt-[14px] mb-[6px]' style={{ fontFamily: "'Bricolage Grotesque', system-ui, sans-serif" }}>
                                    Snacks naturales que tu perro va a amar
                                </h3>
                                <p className='text-[13.5px] opacity-90'>Pollo, salmón y batata. Sin conservadores.</p>
                            </div>
                            <div className='self-start w-[38px] h-[38px] rounded-full bg-white/20 border border-white/30 flex items-center justify-center mt-[14px] group-hover:translate-x-1 transition-transform'>
                                <ArrowIcon />
                            </div>
                        </Link>

                        <Link
                            to='/shops'
                            className='relative rounded-[22px] overflow-hidden p-6 text-white flex flex-col justify-between group'
                            style={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)' }}
                        >
                            <div className='absolute top-[-30px] right-[-30px] w-[140px] h-[140px] rounded-full bg-white/12 pointer-events-none'></div>
                            <span className='self-start bg-white/22 border border-white/30 px-[11px] py-[5px] rounded-full text-[11px] font-extrabold tracking-[.06em] uppercase'>3×2</span>
                            <div>
                                <h3 className='font-bold text-[22px] leading-[1.05] tracking-tight mt-[14px] mb-[6px]' style={{ fontFamily: "'Bricolage Grotesque', system-ui, sans-serif" }}>
                                    Llévate 3, paga 2 en arenas y arenero
                                </h3>
                                <p className='text-[13.5px] opacity-90'>Aglomerantes, perfumadas y sílice.</p>
                            </div>
                            <div className='self-start w-[38px] h-[38px] rounded-full bg-white/20 border border-white/30 flex items-center justify-center mt-[14px] group-hover:translate-x-1 transition-transform'>
                                <ArrowIcon />
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;
